export const topline_config = {
    county: {
        name: 'county_text',
        url: '/static/map_geojson/CWA_Zone.geojson',
        order: 2000,
        weight: 2,
        color: {
            light_map: "transparent",
            dark_map: "transparent"
        },
        map_text_tag: {
            url: {
                tw: '/static/map_geojson/geoCenterCounty.csv',
                en: '/static/map_geojson/en/geoCenterCounty.csv'
            },
            hide_zoom: 8,
            color: {
                light_map: "#5D4037",
                dark_map: "#eee"
            }
        }
    },
    town: {
        name: 'town_text',
        url: '/static/map_geojson/TOWNSHIP_geo.json',
        order: 2001,
        weight: 0.5,
        color: {
            light_map: "#5D4037",
            dark_map: "#666"
        },
        hide_line_zoom: 9,
        map_text_tag: {
            url: {
                tw: '/static/map_geojson/geoCenterTown.csv',
                en: '/static/map_geojson/en/geoCenterTown.csv'
            },
            hide_zoom: 10,
            color: {
                light_map: "#826e6a",
                dark_map: "#666"
            }
        }
    },
}